import React from 'react';
import '../template-file-css/document-file-template.css';


export const RNFI_Hippa = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RNFI_Hippa' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <center> <h3> <b> HIPAA Privacy Rule of Patient Authorization Agreement </b> </h3> </center>
                </p>

                <p className='w-750'> <center> <h4> Authorization for the Disclosure of Protected Health
                    Information for Treatment, Payment, or Healthcare Operations (§164.508(a)) </h4> </center>
                </p>

                <p className='w-750'> I understand that as part of my healthcare, this Practice originates and maintains health records describing my health
                    history, symptoms, examination and test results, diagnosis, treatment, and any plans for future care or treatment. I
                    understand that this information serves as:
                </p>

                <p className='w-750'> <ul> <li> a basis for planning my care and treatment; </li> </ul>
                </p>
                <p className='w-750'> <ul> <li> a means of communication among the health professionals who may contribute to my health care; </li> </ul>
                </p>
                <p className='w-750'> <ul> <li> a source of information for applying my diagnosis and surgical information to my bill; </li> </ul>
                </p>
                <p className='w-750'> <ul> <li> a means by which a third-party payer can verify that services billed were actually provided; </li> </ul>
                </p>
                <p className='w-750'> <ul> <li> a tool for routine health care operations such as assessing quality and reviewing the competence of health care
                    professionals.
                </li> </ul>
                </p>

                <p className='w-750'> I have been provided with a copy of the <b> Notice of Privacy Practices </b> that provides a more complete description of
                    information uses and disclosures.
                </p>
                <p className='w-750'> I understand that as part of my care and treatment it may be necessary to provide my Protected Health Information to
                    another covered entity. I have the right to review this Practice's  notice prior to signing this authorization. I authorize the
                    disclosure of my Protected Health Information as specified below for the purposes and to the parties designated by me.
                </p>

                <p className='w-750'> <center> <h3> <b> Privacy Rule of Patient Consent Agreement </b> </h3> </center>
                </p>

                <p className='w-750'> <center> <h4> AConsent to the Use and Disclosure of Protected Health Information for
                    Treatment, Payment, or Healthcare Operations (§164.506(a) </h4> </center>
                </p>

                <p className='w-750'> I understand that: </p>

                <p className='w-750'> <ul> <li> I have the right to review this Practice's Notice of Information practices prior to signing this consent; </li> </ul>
                </p>
                <p className='w-750'> <ul> <li> that this Practice reserves the right to change the notice and practices and that prior to implementation will mail a
                    copy of any notice to the address I've provided, if requested; </li> </ul>
                </p>
                <p className='w-750'> <ul> <li> I have the right to object to the use of my health information for directory purposes; </li> </ul>
                </p>
                <p className='w-750'> <ul> <li> I have the right to request restrictions as to how my Protected Health Information may be used or disclosed to carry
                    out treatment, payment, or healthcare operations, and that this Practice is not required by law to agree to the
                    restrictions requested; </li> </ul>
                </p>
                <p className='w-750'> <ul> <li> I may revoke this consent in writing at any time, except to the extent that this Practice has already taken action in
                    reliance thereon. </li> </ul>
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'> &nbsp; </td>
                        <td className='signature w-375'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Patient Name: </td>
                        <td className='small w-375'> Signature of Patient or Legal Representative Witness: </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Patient Name: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPatientName' name='txtPatientName' className='add-only' /> </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Appropriately Licensed Practitioner & Credentials </td>
                    </tr>
                </table>




            </div>
        </form>

    )
}











